module.exports = __webpack_public_path__ + "img/OBCINA KOMEN.2cfe38fd.png";